import { translateResourceString } from '../../../util/translationUtility';

// BBS DDD 2017-12-01 This archaic validation could probably be
// replaced. see mapTopLevelPPropsToInitialStore.js for suggestion of valdatejs.org or such
export const validate = (orderDetails, validators) => {
    return validators
        .map(validator =>{
                const key = validator.key;

                if (!!!key) {
                    return `${translateResourceString("/Checkout/PlaceOrder/Errors/UnknownOrderDetail")}: '${key}'`;
                }

                const value = orderDetails[key];
                return validator.validate(value, orderDetails);
            })
        .filter(x => !!x);
  }